import React,{useEffect,useState,useRef} from 'react';
import {useLocation} from 'react-router-dom';
import {analytics} from './service';
import {analyticsNotice} from './notice';
import {sameAccount,watchSessionExpiry} from './sessionIdentity';
import {useAnalyticsPosition} from './useAnalyticsPosition';
import MarketingDialog from '../components/marketing/MarketingDialog';
import Button from '../components/ui/Button';
import {OPEN_ANALYTICS_PREFERENCES} from './AnalyticsPreferences';
import './analytics.css';

const PROMPT_KEY='stirup_analytics_prompt_v1';
function promptDismissed(){try{return JSON.parse(localStorage.getItem(PROMPT_KEY))?.version===analyticsNotice.version;}catch{return false;}}
function rememberDismissal(reason){try{localStorage.setItem(PROMPT_KEY,JSON.stringify({version:analyticsNotice.version,reason}));}catch{}}
function clearDismissal(){try{localStorage.removeItem(PROMPT_KEY);}catch{}}

export default function AnalyticsControls() {
  const {pathname} = useLocation();
  const [state,setState] = useState(analytics.getState), [open,setOpen] = useState(false);
  const [dismissed,setDismissed]=useState(promptDismissed),[accepted,setAccepted]=useState(false),root=useRef(null);
  const previousChoice=useRef(state.choice);
  useAnalyticsPosition(root);
  useEffect(()=>analytics.subscribe(()=>setState(analytics.getState())),[]);
  useEffect(()=>{
    if(previousChoice.current!=='unset'&&state.choice==='unset'){clearDismissal();setDismissed(false);}
    previousChoice.current=state.choice;
  },[state.choice]);
  useEffect(()=>{
    let token = localStorage.getItem('token');
    const reset=()=>{
      // Keep V1's fail-closed identity boundary, independently of modal presentation.
      previousChoice.current='unset';rememberDismissal('identity_reset');
      setOpen(false);setDismissed(true);analytics.resetIdentity();
    };
    let cancelExpiry=watchSessionExpiry(token,reset);
    const changed = event => {
      const next=localStorage.getItem('token');
      if(event?.detail?.reason==='login'||(next!==token&&!sameAccount(token,next))) {
        reset();
      }
      if(next!==token||event?.detail?.reason==='login'){cancelExpiry();cancelExpiry=watchSessionExpiry(next,reset);}
      token=next;
    };
    const stored = event => { if (event.key === 'token' || event.key === null || localStorage.getItem('token')!==token) changed();
      if (event.key === 'stirup_analytics_choice_v1') { analytics.refreshConsent(); }
      if (event.key === PROMPT_KEY) setDismissed(promptDismissed()); };
    window.addEventListener('alc:auth-changed',changed); window.addEventListener('storage',stored);
    return()=>{cancelExpiry();window.removeEventListener('alc:auth-changed',changed);window.removeEventListener('storage',stored);};
  },[]);
  useEffect(()=>{analytics.route(pathname);},[pathname,state.choice]);
  const visible=open || (!dismissed && state.approved && state.choice==='unset');
  useEffect(()=>{if(visible)setAccepted(state.choice!=='denied');},[visible,state.choice]);
  useEffect(()=>{
    const reopen=()=>setOpen(true);
    window.addEventListener(OPEN_ANALYTICS_PREFERENCES,reopen);
    return()=>window.removeEventListener(OPEN_ANALYTICS_PREFERENCES,reopen);
  },[]);
  useEffect(()=>{
    if(!visible)return;
    const overlay=document.querySelector('.analytics-dialog .modal-overlay'),viewport=window.visualViewport;
    const update=()=>{if(overlay&&viewport){overlay.style.top=viewport.offsetTop+'px';overlay.style.height=viewport.height+'px';overlay.style.bottom='auto';}};
    update();viewport?.addEventListener('resize',update);viewport?.addEventListener('scroll',update);
    return()=>{viewport?.removeEventListener('resize',update);viewport?.removeEventListener('scroll',update);};
  },[visible]);
  const close=()=>{if(state.choice==='unset')rememberDismissal('dismissed');setOpen(false);setDismissed(true);};
  const save=()=>{if(analytics.setConsent(accepted?'granted':'denied')){clearDismissal();setOpen(false);setDismissed(true);}};
  return <>
    <aside ref={root} className="analytics-controls" aria-label="Preferenze analytics">
      {!dismissed && state.choice==='unset' && <button type="button" onClick={()=>setOpen(true)} aria-expanded={visible}>Preferenze statistiche</button>}
    </aside>
    <MarketingDialog className="analytics-dialog" open={visible} title="Statistiche facoltative" closeLabel="Non ora" onClose={close}
      primary={<Button disabled={accepted&&!state.approved} onClick={save}>Salva preferenze</Button>}>
      <div className="analytics-notice-text">{analyticsNotice.text}</div>
      {!state.approved && <p>Proposta informativa da approvare: raccolta analytics non attiva.</p>}
      <label className="analytics-accept"><input type="checkbox" checked={accepted} disabled={!state.approved} onChange={e=>setAccepted(e.target.checked)}/> Accetta</label>
    </MarketingDialog>
  </>;
}
